<template>
  <SectionTemplate
    title="全链路可编辑能力 精准掌控每个视频元素"
    sub-title="所有视频元素可编辑"
    :desc="`无论是脚本台词，还是角色形象、语音语调、动作表情，乃至场景选择、镜头切换、字幕贴纸、背景音乐等后期包装元素，\n有言都支持灵活调整。让你像导演一样掌控视频每一个细节。`"
    class="fully-editing"
  >
    <div class="fully-editing__container">
      <div class="fully-editing__video-wrapper">
        <img
          :src="
            getFeUrl(
              '/youyan-platform/ai-avatar-video-generation/fully-editing/sample-mac.png?x-oss-process=image/format,webp',
            )
          "
          alt="全链路编辑"
          class="fully-editing__base"
        />
        <VideoPlayer
          class="fully-editing__video"
          :autoplay="true"
          :muted="isMuted"
          :enable-fullscreen="false"
          :poster-transform="undefined"
          :poster="
            getFeUrl(
              '/youyan-platform/ai-avatar-video-generation/fully-editing/cover.png?x-oss-process=image/format,webp',
            )
          "
          :url="
            getFeUrl('/youyan-platform/ai-avatar-video-generation/fully-editing/fully-editing.m3u8')
          "
          title="无需拍摄剪辑，只需输入文字，使用有言即可一键生成高质量3D数字人视频"
        />
      </div>
    </div>
    <TrailBtn />
  </SectionTemplate>
</template>

<script setup lang="ts">
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import VideoPlayer from '~/components/video-player/index.vue';
import TrailBtn from '../../components/trail-btn.vue';

const isMuted = inject<boolean>('isMuted') || true;
</script>

<style lang="scss" scoped src="./mobile.scss"></style>
<style lang="scss" scoped src="./pc.scss" />
